export default {
  cn: {
    pleaseSelect: '请选择',
    defaultHead: '行政区划选择器',
    clear: '清除选择的项目',
    done: '完成',
    noMatch: '无匹配项目'
  },
  en: {
    pleaseSelect: 'Please select',
    defaultHead: 'Region selector',
    clear: 'Clear selected region',
    done: 'Done',
    noMatch: 'No matched items'
  }
}



// WEBPACK FOOTER //
// ./src/language.js